"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityPicker = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const QuantityPicker = exports.QuantityPicker = (0, _mui.styled)(_components.QuantityPicker)(({
  theme
}) => ({
  margin: theme.spacing(0, 4)
}));
